@import '../../../../style/lib/scss';
@import '../../../../style/src/typography/mixins';

.zds-alert {
	@include zds-typography('body');

	border-radius: var(--zds-shape-radius-lg);
	display: flex;
	flex-direction: column;
	padding: var(--zds-space-4);

	@include zds-media-breakpoint-down('xs') {
		padding: var(--zds-space-2) var(--zds-space-3);
	}

	&--error {
		background-color: var(--zds-color-danger);
		color: var(--zds-color-danger-foreground);
	}

	&--info {
		background-color: var(--zds-color-info);
		color: var(--zds-color-info-foreground);
	}

	&--success {
		background-color: var(--zds-color-success);
		color: var(--zds-color-success-foreground);
	}

	&--warning {
		background-color: var(--zds-color-warning);
		color: var(--zds-color-warning-foreground);
	}

	&__body,
	&__title {
		display: flex;
	}

	&__title {
		align-items: center;
		display: flex;
		font-weight: var(--zds-typography-headline-font-weight);
	}

	&__icon {
		margin-right: var(--zds-space-3);
	}
}
